import { InferValueTypes } from '~/src/store';

import * as ActionCreators from './actions';

export const ActionTypes = {
    SHOW_POPUP: '@popup/show',
    HIDE_POPUP: '@popup/hide',
    RESET_POPUP: '@popup/reset',
    SET_POPUP_DATA: '@popups/set_popup_data',
} as const;

export type TActions = ReturnType<InferValueTypes<typeof ActionCreators>>;

export interface IPopupData {
    isShow: boolean,
    data: Record<string, unknown>,
}

export type TPopups = Record<string, IPopupData>;

/**
 * Управление отображением/скрытием попапов
 * @param {boolean} isShow - показать/скрыть попап
 * @param {object} data - данные для попапа
 */

// eslint-disable-next-line default-param-last
export const popups = (state: TPopups = {}, action: TActions): TPopups => {
    switch (action.type) {
        case ActionTypes.SHOW_POPUP: {
            const { popupId, data } = action.payload;
            const currPopup = state[popupId];

            return {
                ...state,
                [popupId]: {
                    ...currPopup,
                    isShow: true,
                    data: data || {},
                },
            };
        }
        case ActionTypes.HIDE_POPUP: {
            const { popupId } = action.payload;

            return {
                ...state,
                [popupId]: {
                    isShow: false,
                    data: {},
                },
            };
        }
        case ActionTypes.RESET_POPUP: {
            return {};
        }
        case ActionTypes.SET_POPUP_DATA: {
            const { popupId, data } = action.payload;
            const currPopup = state[popupId];

            return {
                ...state,
                [popupId]: {
                    isShow: !!currPopup?.isShow,
                    data: data || {},
                },
            };
        }
        default: {
            const unknownAction: never = action;
            return state || unknownAction;
        }
    }
};
